import { TaxCategoriesGridView } from '~/components/prices/tax-categories';
import { PageContainer } from '~/components/page-container';

export function TaxCategories() {
	return (
		<PageContainer>
			<TaxCategoriesGridView />
		</PageContainer>
	);
}
